var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Layout,{attrs:{"hide-mobile-menu-bar":true}},[_c('div',{staticClass:"mobile-search-bar"},[_c(_setup.SearchBar)],1),_c('BaseContent',{staticClass:"search-area"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }